import { Atom, atom } from 'jotai';
import { $ABTest } from '@lemon8/web-app-shared/atom';
import _get from 'lodash/get';

export const $LandingModalStyle = atom((get) => {
  const { parameters } = get($ABTest);

  if (process.env.NODE_ENV === 'development') {
    return 0;
  }

  return _get(parameters, ['seo_web', 'lemon8.landing_modal_style'], 0);
});

export const $HitNewLandingModalStyle: Atom<boolean> = atom((get) => {
  const config = get($LandingModalStyle);

  return config >= 1;
});

export const $HitLandingModalMaskClickClose: Atom<boolean> = atom((get) => {
  const config = get($LandingModalStyle);

  return config >= 2;
});

export const $HitNewLandingModalButton: Atom<boolean> = atom((get) => {
  const config = get($LandingModalStyle);

  return config === 3;
});
